import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Faq() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    return (
        <section id="faq" className="faq section">
            <div className="container section-title" data-aos="fade-up">
                <h2>Frequently Asked Questions</h2>
                <div>
                    <span className="description-title">Frequently Asked Questions</span>
                </div>
            </div>

            <div className="container">
                <div className="row faq-item" data-aos="fade-up" data-aos-delay="100">
                    <div className="col-lg-5 d-flex">
                        <i className="bi bi-question-circle"></i>
                        <h4>What services does GANPATI COMPUTERS offer?</h4>
                    </div>
                    <div className="col-lg-7">
                        <p>
                            We provide comprehensive computer and printer repair services, including hardware & software troubleshooting, SSD upgrades, hard disk recovery, custom PC building, printer repair (all brands), networking solutions, AMC (Annual Maintenance Contracts), and genuine spare parts for desktops and laptops.
                        </p>
                    </div>
                </div>

                <div className="row faq-item" data-aos="fade-up" data-aos-delay="200">
                    <div className="col-lg-5 d-flex">
                        <i className="bi bi-question-circle"></i>
                        <h4>Do you offer on-site or doorstep repair services?</h4>
                    </div>
                    <div className="col-lg-7">
                        <p>
                            Yes, we provide on-site support for businesses and AMC customers. For individual clients, we recommend visiting our shop at <strong>Nau Gaja Peer, College Road, Ropar</strong> for faster service. However, we can arrange doorstep pickup and delivery for certain repairs – please call us to confirm.
                        </p>
                    </div>
                </div>

                <div className="row faq-item" data-aos="fade-up" data-aos-delay="300">
                    <div className="col-lg-5 d-flex">
                        <i className="bi bi-question-circle"></i>
                        <h4>How can I contact GANPATI COMPUTERS for support?</h4>
                    </div>
                    <div className="col-lg-7">
                        <p>
                            You can reach us by phone at <a href="tel:9988893537">99888-93537</a> or visit our shop directly at Nau Gaja Peer, College Road, Ropar. We're happy to answer your questions, provide quotes, or schedule a service appointment.
                        </p>
                    </div>
                </div>

                <div className="row faq-item" data-aos="fade-up" data-aos-delay="400">
                    <div className="col-lg-5 d-flex">
                        <i className="bi bi-question-circle"></i>
                        <h4>What are your operating hours?</h4>
                    </div>
                    <div className="col-lg-7">
                        <p>
                            We are open Monday to Saturday from 10:00 AM to 8:00 PM. On Sundays, we remain closed. For urgent repairs or special appointments, please contact us in advance and we'll do our best to accommodate you.
                        </p>
                    </div>
                </div>

                <div className="row faq-item" data-aos="fade-up" data-aos-delay="500">
                    <div className="col-lg-5 d-flex">
                        <i className="bi bi-question-circle"></i>
                        <h4>Do you sell computer spare parts and accessories?</h4>
                    </div>
                    <div className="col-lg-7">
                        <p>
                            Absolutely! We stock a wide range of genuine spare parts including SSDs, hard disks, RAM, motherboards, power supplies, keyboards, and more. Visit our shop to find the right component for your PC or laptop upgrade.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Faq;